__turbopack_context__.v({
  "darkBackground": "socialmediaiconlinks-module-scss-module__tkjxOG__darkBackground",
  "darkTheme": "socialmediaiconlinks-module-scss-module__tkjxOG__darkTheme",
  "emailIcon": "socialmediaiconlinks-module-scss-module__tkjxOG__emailIcon",
  "list": "socialmediaiconlinks-module-scss-module__tkjxOG__list",
  "wrapIcons": "socialmediaiconlinks-module-scss-module__tkjxOG__wrapIcons",
});
